<template>
  <v-form ref="form" flat class="pt-5">
    <div class="d-flex pt-2">
      <AutocompleteSubjectGroup
        return-object
        item-text="title"
        item-value="id"
        label="Bộ môn"
        class="required"
        deletable-chips
        dense
        :rules="[$rules.required]"
        required
        outlined
        v-model="subjectGroup"
      />
    </div>
    <div class="d-flex mr-4">
      <AutocompleteGrade
        return-object
        v-model="grade"
        item-text="title"
        item-value="id"
        label="Học phần"
        class="required col-md-6 mr-4"
        :rules="[$rules.required]"
        required
        dense
        outlined
        @change="gradeChanged"
      />
      <AutocompleteDivision
        return-object
        v-model="division"
        item-text="title"
        item-value="id"
        label="Phân ban"
        class="required col-md-6"
        clear-icon="mdi-close"
        :rules="[$rules.required]"
        outlined
        required
        dense
        deletable-chips
        :filter="divisionFilter"
        @change="divisionChanged"
      />
    </div>
    <div class="mb-2">
      <v-text-field
        label="Tên môn học"
        class="required"
        :rules="[$rules.required, titleRule]"
        v-model="title"
        disabled
        dense
        outlined
        required
      ></v-text-field>
    </div>
    <div class="mt-n2">
      <v-text-field
        label="Hệ số tổng kết"
        class="required"
        :rules="[$rules.required, $rules.min(0)]"
        v-model="multiply"
        dense
        outlined
        required
        type="number"
      ></v-text-field>
    </div>
    <v-radio-group row class="shrink mt-n2" mandatory v-model="markType">
      <v-radio label="Đánh giá theo điểm số" hide-details value="mark"></v-radio>
      <v-radio label="Đánh giá theo nhận xét" hide-details value="evaluate"></v-radio>
    </v-radio-group>
    <div class="d-flex mr-4">
      <v-text-field
        label="Số tiết tối thiểu trên tuần"
        class="required col-md-6 mr-4"
        :rules="[$rules.required, $rules.min(0), $rules.max(maxWeeklyLesson)]"
        min="0"
        v-model="minWeeklyLesson"
        dense
        outlined
        required
        type="number"
      ></v-text-field>
      <v-text-field
        label="Số tiết tối đa trên tuần"
        class="required col-md-6"
        :rules="[$rules.required, $rules.min(0), $rules.min(minWeeklyLesson)]"
        min="0"
        v-model="maxWeeklyLesson"
        dense
        outlined
        required
        type="number"
      ></v-text-field>
    </div>
    <v-checkbox v-model="compoundClass" label="Ghép lớp" class="mt-n2 mb-n4"> </v-checkbox>
  </v-form>
</template>
<script>
import AutocompleteGrade from '@/components/basic/input/AutocompleteGrade'
import AutocompleteDivision from '@/components/basic/input/AutocompleteDivision'
import AutocompleteSubjectGroup from '@/components/basic/input/AutocompleteSubjectGroup'
import { textHelpers } from '@/helpers/TextHelper.js'
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import map from 'lodash-es/map'

const defaultSubjectTypes = [
  { id: 'coreCurriculum', title: 'Chính khoá' },
  { id: 'extraCurriculum', title: 'Ngoại khoá' },
]
export default {
  components: {
    AutocompleteDivision,
    AutocompleteGrade,
    AutocompleteSubjectGroup,
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      title: '',
      grade: '',
      markType: 'mark',
      multiply: '',
      division: '',
      type: '',
      lessonPerYear: '',
      minWeeklyLesson: '',
      maxWeeklyLesson: '',
      compoundClass: false,
      subjectGroup: '',
      defaultSubjectTypes: defaultSubjectTypes,
      titleRule: (v) => {
        const title = textHelpers.removeSpaces(v)
        return !map(this.subjects, 'title').includes(title) || 'Đã có môn học này'
      },
    }
  },
  methods: {
    gennerateTitle() {
      if (get(this.subjectGroup, 'title') && get(this.grade, 'title') && get(this.division, 'title')) {
        if (this.division.title.toLowerCase().includes('không phân ban')) {
          // const titleSuffix = this.grade.academicLevel.title
          this.title = this.subjectGroupText + ' ' + this.gradeText // + ` (${titleSuffix})`
        } else {
          this.title = this.subjectGroupText + ' ' + this.gradeText + ' ' + this.divisionText
        }
      }
    },
    getData() {
      if (this.$refs.form.validate()) {
        return {
          title: textHelpers.removeSpaces(this.title),
          type: 'coreCurriculum',
          markType: this.markType,
          multiply: this.multiply,
          grade: this.grade.id,
          division: this.division.id,
          subjectGroup: this.subjectGroup.id,
          data: {
            lessonPerYear: this.lessonPerYear,
            minWeeklyLesson: this.minWeeklyLesson,
            maxWeeklyLesson: this.maxWeeklyLesson,
            compoundClass: this.compoundClass,
          },
        }
      }
      return null
    },
    gradeChanged(grade) {
      this.division = null
      this.grade = grade
      this.resetValidation()
    },
    divisionChanged(division) {
      this.division = division
      this.resetValidation()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
  computed: {
    ...mapState('subjects', ['subjects']),
    divisionFilter() {
      return { academicLevel: get(this.grade, 'academicLevel.id') }
    },
    subjectGroupText() {
      return get(this.subjectGroup, 'title', '')
    },
    gradeText() {
      return get(this.grade, 'gradeNumber', '')
    },
    divisionText() {
      return get(this.division, 'title', '')
    },
  },
  watch: {
    state(state) {
      if (!state) {
        this.$refs.form.reset()
      }
    },
    maxWeeklyLesson: 'resetValidation',
    minWeeklyLesson: 'resetValidation',
    multiply: 'resetValidation',
    title: 'resetValidation',
    subjectGroup: 'gennerateTitle',
    grade: 'gennerateTitle',
    division: 'gennerateTitle',
  },
}
</script>
